import React, { useState, useEffect } from "react";
import "./deliveryButton.css"; // Assicurati di importare il tuo foglio di stile

const DeliveryButton = () => {
  const [isAnimating, setAnimating] = useState(false);

  const handleClick = () => {
    if (!isAnimating) {
      setAnimating(true);
      setTimeout(() => {
        setAnimating(false);
      }, 10000);
    }
  };

  useEffect(() => {
    // Aggiungi altri effetti o azioni desiderate qui
  }, []); // L'array vuoto indica che l'effetto deve essere eseguito solo una volta, simile a componentDidMount

  return (
    <div>
      {/* Aggiungi qui il codice HTML del tuo pulsante e degli altri elementi */}
      <button
        className={`order ${isAnimating ? "animate" : ""}`}
        onClick={handleClick}
      >
        <span className="default">Ordina Suolette</span>
        <span className="success">
          Ordine Completato
          <svg viewBox="0 0 12 10">
            <polyline points="1.5 6 4.5 9 10.5 1" />
          </svg>
        </span>
        <div className="box"></div>
        <div className="truck">
          <div className="back"></div>
          <div className="front">
            <div className="window"></div>
          </div>
          <div className="light top"></div>
          <div className="light bottom"></div>
        </div>
        <div className="lines"></div>
      </button>
    </div>
  );
};

export default DeliveryButton;
